"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This module provides methods for Addresses, setting / updating addresses on specific
 * objects like customer  and order are done directly on those objects
 *
 * @preferred
 */
var base_1 = require("./base");
var service_1 = require("../service");
var AddressBook = /** @class */ (function (_super) {
    __extends(AddressBook, _super);
    /**
     * Creates an instance of AddressBook.
     *
     * @param {number} [limit=15] The number of address book items to return
     * @param {number} [start=0] The number of address book items to skip
     * @param {EVA.Framework.SortDirection} [sortDirection=0] The sort direction for the addresses
     * @param {string} [sortProperty=null] The property to sort on
     * @memberof AddressBook
     */
    function AddressBook(limit, start, sortDirection, sortProperty) {
        if (limit === void 0) { limit = 15; }
        if (start === void 0) { start = 0; }
        if (sortDirection === void 0) { sortDirection = 0; }
        if (sortProperty === void 0) { sortProperty = null; }
        return _super.call(this, limit, start, sortDirection, sortProperty) || this;
    }
    AddressBook.setDefaultBillingAddress = function (id) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("SetDefaultBillingAddress");
            // Build the request data
            // The base class will add things like SessionID so keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                AddressBookID: id
            };
            service.call(requestData)
                .then(function (serviceResult) {
                resolve(serviceResult.response);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    AddressBook.setDefaultShippingAddress = function (id) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("SetDefaultShippingAddress");
            // Build the request data
            // The base class will add things like SessionID so keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                AddressBookID: id
            };
            service.call(requestData)
                .then(function (serviceResult) {
                resolve(serviceResult.response);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    AddressBook.createItem = function (address, description) {
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("CreateAddressBookItem");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                Description: description || "",
                Address: address
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (serviceResult) {
                resolve(serviceResult.response);
            })
                .catch(reject);
        });
    };
    AddressBook.updateItem = function (id, address, description) {
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("UpdateAddressBookItem");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                ID: id,
                Description: description || "",
                Address: address
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function () {
                resolve();
            })
                .catch(reject);
        });
    };
    AddressBook.deleteItem = function (id) {
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("DeleteAddressBookItem");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                ID: id
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function () {
                resolve();
            })
                .catch(reject);
        });
    };
    /**
     * Sets the user to retrieve the address list for.
     * Only employees may fetch and update for other users
     *
     * @param {number} userId The user identifier
     * @returns
     * @memberof AddressBook
     */
    AddressBook.prototype.setUserId = function (userId) {
        return this.userId = userId;
    };
    /**
     * Fetches the list of items
     * @return {Promise<IEVAServiceResponse<EVA.Core.Services.ListAddressBook, EVA.Core.Services.ListAddressBookResponse>>} A promise resolving when the fetch from the back-end has completed
     */
    AddressBook.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            UserID: this.userId
        };
        return _super.prototype.fetch.call(this, "ListAddressBook", requestData);
    };
    return AddressBook;
}(base_1.FetchablePagedList));
exports.AddressBook = AddressBook;
var Addresses;
(function (Addresses) {
    /**
     * Wrapper class for Address responses, since this is not a fetchable item
     * it's just a plain object
     */
    var Address = /** @class */ (function () {
        function Address() {
        }
        Address.prototype.setData = function (response) {
            return this.data = response.Result;
        };
        return Address;
    }());
    Addresses.Address = Address;
    /**
     * Perform a lookup using zipcode and housenumber, resolve with an Address object
     *
     * @param  {string}  zipCode     zipcode to lookup
     * @param  {string}  houseNumber housenumber to lookup
     * @return {Promise}             [description]
     */
    function lookup(zipCode, houseNumber) {
        var service = new service_1.EVAService("GetAddressForZipCode");
        // Build the request data
        // The base class will add things like SessionID so keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            ZipCode: zipCode,
            HouseNumber: houseNumber
        };
        return new Promise(function (resolve, reject) {
            // Perform the call and capture the resulting promise
            //
            service.call(requestData).then(function (serviceResult) {
                var address = new Address();
                address.setData(serviceResult.response);
                resolve(address);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    }
    Addresses.lookup = lookup;
    /**
     * Request a list of available countries for a user to create addresses with
     * @return {Promise}
     */
    function getAvailableCountries() {
        var service = new service_1.EVAService("ListCountries");
        return new Promise(function (resolve, reject) {
            // Perform the call and capture the resulting promise
            //
            service.call().then(function (serviceResult) {
                resolve(serviceResult.response);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    }
    Addresses.getAvailableCountries = getAvailableCountries;
    /**
     * Perform an address search using a single text string, responds with textual suggestions.
     * To get the details of the suggestion (city/street etc) a additional call
     * needs to be made to getAddressSuggestionDetails()
     *
     * @param {string}      query       The search query
     * @return {Promise}    array of found suggestions
     */
    function getAddressSuggestions(query) {
        var service = new service_1.EVAService("AutocompleteAddress");
        // Build the request data
        // The base class will add things like SessionID so keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            Query: query
        };
        return new Promise(function (resolve, reject) {
            // Perform the call and capture the resulting promise
            //
            service.call(requestData).then(function (serviceResult) {
                resolve(serviceResult.response);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    }
    Addresses.getAddressSuggestions = getAddressSuggestions;
    /**
     * Retrieve the details of a suggestion
     *
     * @param {EVA.Core.AddressSuggestion}      suggestion      the address suggestion, can be retrieved using the getAddressSuggestions() function
     * @return {Promise}    the details of the address suggestion
     */
    function getAddressSuggestionDetails(suggestion) {
        var service = new service_1.EVAService("GetAutocompleteAddressByReference");
        // Build the request data
        // The base class will add things like SessionID so keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            Suggestion: suggestion
        };
        return new Promise(function (resolve, reject) {
            // Perform the call and capture the resulting promise
            //
            service.call(requestData).then(function (serviceResult) {
                resolve(serviceResult.response);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    }
    Addresses.getAddressSuggestionDetails = getAddressSuggestionDetails;
})(Addresses = exports.Addresses || (exports.Addresses = {}));
